define.alias("shared/utils/emoji-picker", "calendar/utils/emoji-picker");